<template>
  <transition name="fade">
    <div class="level3-landingpage-container">
      <div class="lv3-title-text">Tambah {{ label }}</div>
      <div class="lv3-edit-form" style="overflow-y: auto !important">
        <div class="edit-form-wrapper">
          <div>Posisi</div>
          <input class="lv3-input-text" type="text" v-model="position"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Jumlah Karyawan</div>
          <input class="lv3-input-text" type="number" v-model="total_employee" />
        </div>
        <div class="edit-form-wrapper">
          <div>Kompetensi Umum / Khusus</div>
          <input class="lv3-input-text" type="text" v-model="competencies"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Pengalaman Kerja</div>
          <input class="lv3-input-text" type="number" v-model="exp" />
        </div>
        <div class="edit-form-wrapper">
          <div>Dokumen Pendukung</div>
          <label class="btn btn-default btn-file">
            <i class="fas fa-upload"></i>
            <span class="all-column">{{
        doc && doc.fileName
          ? doc.fileName
          : doc && doc.original_name
            ? doc.original_name
            : 'Upload'
      }}</span>
            <input type="file" style="display: none;" @change="fileChangeHandler($event)" />
          </label>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="submitForm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import axios from 'axios'
import { api_lp } from '../../services/config'
export default {
  props: [
    'label',
    'modelName',
    'isRequired',
    'mutationName',
    'arrayMutation',
    'storeName',
    'modalName',
  ],
  data() {
    return {
      document_id: null,
    }
  },
  computed: {
    position: {
      get() {
        return this.$store.state[this.storeName]['skill_position']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'skill_position',
          value: newValue,
        })
      },
    },
    total_employee: {
      get() {
        return this.$store.state[this.storeName]['skill_total_employee']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'skill_total_employee',
          value: newValue,
        })
      },
    },
    competencies: {
      get() {
        return this.$store.state[this.storeName]['skill_competencies']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'skill_competencies',
          value: newValue,
        })
      },
    },
    exp: {
      get() {
        return this.$store.state[this.storeName]['skill_exp']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'skill_exp',
          value: newValue,
        })
      },
    },
    doc: {
      get() {
        return this.$store.state[this.storeName]['skill_doc']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'skill_doc',
          value: newValue,
        })
      },
    },
  },
  methods: {
    closeModal() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: false,
      })
      this.$store.commit(this.mutationName, {
        name: 'skill_add',
        value: false,
      })
    },
    async submitForm() {
      try {
        const submitedData = {
          request_id: this.$store['state'][this.storeName]['request_id'],
          k3l_doc_id: this.document_id
            ? this.document_id
            : this.$get(this.$store, `state.${this.storeName}.skill_doc.id`),
          posisi: this.position,
          jumlah: this.total_employee,
          umum_khusus: this.competencies,
          pengalaman_kerja: this.exp,
        }

        let url = `${api_lp}/api/v1/vendor/competensies`
        if (!this.$store.state[this.storeName]['skill_add']) {
          url = `${api_lp}/api/v1/vendor/competensies/${this.$store['state'][this.storeName]['skill_id']
            }`
        }
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

        const { data } = await axios({
          method: this.$store.state[this.storeName]['skill_add']
            ? 'POST'
            : 'PUT',
          url,
          data: submitedData,
        })

        if (data && data.status == 'success') {
          await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          await this.$store.commit(this.mutationName, {
            name: this.modelName,
            value: data.data,
          })
          await this.$store.commit(this.mutationName, {
            name: 'skill_position',
            value: null,
          })
          await this.$store.commit(this.mutationName, {
            name: 'skill_total_employee',
            value: null,
          })
          await this.$store.commit(this.mutationName, {
            name: 'skill_competencies',
            value: null,
          })
          await this.$store.commit(this.mutationName, {
            name: 'skill_exp',
            value: null,
          })
          await this.$store.commit(this.mutationName, {
            name: 'skill_doc',
            value: null,
          })
          await this.closeModal()
        }
      } catch (error) {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
      }
    },
    fileChangeHandler(e) {
      let fileHandler = Array.from(e.target.files)
      let fileType = fileHandler[0].type
      let fileName = fileHandler[0].name

      fileHandler['file'] = fileHandler
      fileHandler['fileName'] = fileHandler[0].name

      if (
        fileType.search(/jpeg|jpg|pdf|xls|zip|rar/i) >= 0 ||
        fileName.search(/.rar/gi) >= 0
      ) {
        this.doc = fileHandler
        this.uploadFile(fileHandler[0])
      } else {
        alert('Jenis File ini tidak dapat di upload')
      }
    },
    async uploadFile(file) {
      try {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

        const url = `${api_lp}/api/v1/vendor/k3l-dokument`

        let bodyFormData = new FormData()
        bodyFormData.append(
          'request_id',
          this.$store['state'][this.storeName]['request_id']
        )
        bodyFormData.append('m_k3l_doc_id', 2)
        bodyFormData.append('k3l_document_lampiran[]', file)

        const { data } = await axios({
          method: 'POST',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (data.status == 'success') {
          this.document_id = data.data.id
          this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
      }
    },
  },
}
</script>
